var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSolarMarketplace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8381 5.88279C23.981 5.27811 23.6066 4.67213 23.002 4.5293H12.9955C12.3908 4.67213 12.0165 5.27811 12.1593 5.88279C12.7844 8.52902 15.1601 10.4992 17.9987 10.4992C20.8373 10.4992 23.213 8.52902 23.8381 5.88279Z",
    fill: "#171717",
    fillOpacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 4.5C5.00368 4.5 4.5 5.00368 4.5 5.625C4.5 6.24633 5.00368 6.75 5.625 6.75H7.875C8.49633 6.75 9 6.24633 9 5.625C9 5.00368 8.49633 4.5 7.875 4.5H5.625Z",
    fill: "#171717",
    fillOpacity: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.125 4.5C27.5037 4.5 27 5.00368 27 5.625C27 6.24633 27.5037 6.75 28.125 6.75H30.375C30.9963 6.75 31.5 6.24633 31.5 5.625C31.5 5.00368 30.9963 4.5 30.375 4.5H28.125Z",
    fill: "#171717",
    fillOpacity: 0.9
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0455 12.7955C12.4848 12.3562 12.4848 11.6439 12.0455 11.2045C11.6062 10.7652 10.8939 10.7652 10.4545 11.2045L8.9545 12.7045C8.51517 13.1439 8.51517 13.8562 8.9545 14.2955C9.39385 14.7348 10.1062 14.7348 10.5455 14.2955L12.0455 12.7955Z",
    fill: "#171717",
    fillOpacity: 0.9
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5454 11.2045C25.1061 10.7652 24.3939 10.7652 23.9545 11.2045C23.5152 11.6439 23.5152 12.3562 23.9545 12.7955L25.4545 14.2955C25.8939 14.7348 26.6061 14.7348 27.0454 14.2955C27.4848 13.8562 27.4848 13.1439 27.0454 12.7045L25.5454 11.2045Z",
    fill: "#171717",
    fillOpacity: 0.9
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.125 14.625C19.125 14.0037 18.6213 13.5 18 13.5C17.3787 13.5 16.875 14.0037 16.875 14.625V16.875C16.875 17.4963 17.3787 18 18 18C18.6213 18 19.125 17.4963 19.125 16.875V14.625Z",
    fill: "#171717",
    fillOpacity: 0.9
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.20834 22.5C6.76792 22.5 6.36802 22.757 6.18504 23.1576L3.10171 29.9076C2.94262 30.2559 2.97159 30.6611 3.17856 30.9833C3.38554 31.3053 3.74214 31.5 4.125 31.5H15.75C16.3713 31.5 16.875 30.9963 16.875 30.375V23.625C16.875 23.0037 16.3713 22.5 15.75 22.5H7.20834Z",
    fill: "#171717",
    fillOpacity: 0.9
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 22.5C19.6287 22.5 19.125 23.0037 19.125 23.625V30.375C19.125 30.9963 19.6287 31.5 20.25 31.5H31.875C32.2578 31.5 32.6145 31.3053 32.8215 30.9833C33.0284 30.6611 33.0574 30.2559 32.8983 29.9076L29.8149 23.1576C29.6321 22.757 29.232 22.5 28.7916 22.5H20.25Z",
    fill: "#171717",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarMarketplace);
export default __webpack_public_path__ + "static/media/solar-marketplace.6665a1391c6516b21f054662dc72ccef.svg";
export { ForwardRef as ReactComponent };